import { HTTP_RESPONSE_ERROR } from "./constants";

export function catchResponseError(error) {
  return {
    type: HTTP_RESPONSE_ERROR,
    payload: error,
  };
}
